import { useIsFocused, useNavigation } from '@react-navigation/core'
import React, { useEffect, useContext, useState } from 'react'
import { ProjectDetailsContext } from './ProjectDetails'
import { routes } from '@linqpal/models'
import Loading from '../../../Loading'
import { ListPlaceholder } from '../../../../ui/atoms/ListPlaceholder'
import { Image } from 'react-native'
import noInvoice from '../../../../assets/images/noInvoice.svg'
import { InvoicesListDisplay } from '../../InvoicesTab/InvoicesListDisplay'
import { ScrollView } from 'react-native-gesture-handler'
import { useTranslation } from 'react-i18next'

export const ProjectInvoices = ({ route }) => {
  const { t } = useTranslation('global')
  const isFocused = useIsFocused()
  const { project, projectInvoices, setProjectInvoices } = useContext(
    ProjectDetailsContext,
  )
  const [loading, setLoading] = useState(true)

  const navigation = useNavigation()

  useEffect(() => {
    if (project) {
      const req = routes.invoices.listFromArray(project.invoices)
      req
        .then((res) => {
          setProjectInvoices(res.invoices)
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    }
  }, [project, isFocused])

  if (loading) {
    return <Loading />
  }
  return (
    <ScrollView style={{ backgroundColor: 'white' }}>
      {projectInvoices.length === 0 ? (
        <ListPlaceholder
          image={
            <Image
              style={{
                marginHorizontal: 70,
                width: '70%',
                height: 230,
                alignSelf: 'center',
              }}
              source={noInvoice}
            />
          }
          heading={t('Projects.no_invoices')}
        />
      ) : (
        <InvoicesListDisplay
          navigation={navigation}
          invoices={projectInvoices}
          route={route}
        />
      )}
    </ScrollView>
  )
}
